export const ENROLLMENT_STATUS = {
  NONE: 0,
  ERROR: 1,
  ENROLLED: 2,
  ENROLLED_AND_ACCEPTED_TERMS: 3,
  PENDING_VERIFICATION: 4,
  AUTHENTICATED: 5,
  REJECTED: 6,
  NOT_ACTIVE: 7,
};

export const TOASTER_DURATION = 5000;
